import { useEffect } from 'react'
import { useSelector } from 'react-redux'
import { useDispatch } from 'react-redux'
import { setPromotedCoursesFetched } from 'store/Dashboard/actions'
import { setPromotedCourses } from 'store/Dashboard/actions'
import AxiosInstance from 'utils/AxiosInstance'

export function usePromotedCourses() {
  const dispatch = useDispatch()

  const { promotedCoursesFetched } = useSelector((state) => state.dashboard)
  const { courses } = useSelector((state) => state.courses)

  const fetchPromotedCourses = () => {
    dispatch(setPromotedCourses({ loadingPromotedCourses: true }))

    AxiosInstance.get('/courses/promote-to-dashboard').then((data) => {
      dispatch(setPromotedCourses({ loadingPromotedCourses: false }))

      dispatch(setPromotedCourses({ promotedCourses: data }))
      dispatch(setPromotedCoursesFetched(true))
    })
  }

  useEffect(() => {
    if (promotedCoursesFetched) return
    fetchPromotedCourses()
  }, [promotedCoursesFetched])

  return null
}
